import React from 'react'
import { motion } from 'framer-motion'

import {
  IoIosCheckmarkCircle,
  IoIosCloseCircle,
  IoIosInformationCircle,
  IoIosWarning,
} from 'react-icons/io'
import { BiLoaderAlt } from 'react-icons/bi'

/**
 * Componente SnackBar que se encarga de renderizar de manera dinamica el mensaje toast a mostrar.
 * Este componente es llamado en SnackBarContext.ts
 * @param {String} message Mensaje que se mostrará.
 * @param {String} Status Dependiendo del status, muestra iconos diferentes.
 */
const SnackBar: React.FC<SnackBarProps> = ({ message, status = 'default' }) => {
  const renderIcon = () => {
    switch (status) {
      case 'success':
        return (
          <IoIosCheckmarkCircle className="text-success dark:text-success-dark" />
        )
      case 'info':
        return (
          <IoIosInformationCircle className="text-blue-500  dark:text-blue-600" />
        )
      case 'warning':
        return <IoIosWarning className="text-yellow-300 dark:text-yellow-400" />
      case 'error':
        return (
          <IoIosCloseCircle className="text-danger dark:text-danger-dark" />
        )
      case 'loading':
        return (
          <BiLoaderAlt className="animate-spin text-primary dark:text-primary-dark" />
        )
      default:
        return null
    }
  }

  return (
    <motion.div
      className="flex top-3 left-0 w-full justify-center px-4 fixed"
      style={{ zIndex: 150 }}
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50, transition: { duration: 0.2 } }}
    >
      <div className="px-4 py-2 w-max z-50 flex shadow-md max-w-sm bg-white dark:bg-dark-less rounded-lg items-center h-12">
        {renderIcon()}
        <p className="ml-1">{message}</p>
      </div>
    </motion.div>
  )
}

export default SnackBar

interface SnackBarProps {
  duration?: number
  message: string
  status?: 'success' | 'error' | 'warning' | 'info' | 'default' | 'loading'
}
